import React from "react";

const ImageDownload = () => {
	return (
		<svg
			className="image-download unclickable"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			width="24"
			height="24"
			viewBox="0 0 24 24"
		>
			<path
				className="image-fill-color"
				d="M5.5,11.6l-1-1V8l6.5,6.5v-13h2v13L19.5,8v2.6l-1,1L12,18.1L5.5,11.6z M4,20.5h16l2,2H2L4,20.5z"
			/>
		</svg>
	);
};

export default ImageDownload;
